import React from 'react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import { KTSVG } from 'src/_metronic/helpers';

const Dashboard = () => {
  const loginData: any = localStorage.getItem('branch')
  const currentUser = JSON.parse(loginData)
  const navigate = useNavigate();
   document.title = `PANEL | Dashboard`
  //   useEffect(() => {
  //     // Set the title when the component mounts
  //     const originalTitle = document.title; // Store the original title
  //     document.title = `PANEL - Dashboard`
  
  //     // Cleanup: Revert to the original title (or a default) when unmounting
  //     return () => {
  //         document.title = originalTitle; // Or set a default like "My App"
  //     }
  // }, [currentUser.branch_name])
  return (
    <div>
      Dashboard
      <div
              className="btn btn-icon btn-shadow-lg  bg-primary text-white position-absolute start-100 translate-middle d-flex align-items-center justify-content-center border border-light"
              style={{ zIndex: 99, top: "33px", marginLeft: "-34px" ,width: "34px",
                height: "32px"}}
              role="button"
              aria-label="Go back to previous page"
              tabIndex={0}
              data-tooltip="Back"
              onClick={() => navigate(-1)}
            >
              <KTSVG path="/media/icons/duotune/arrows/arr025.svg" className="svg-icon-4 text-white" />
            </div>
      {/* <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', marginTop: '10px' }}>
              <button onClick={() => navigate(-1)} className="btn btn-secondary">
                ← Back
              </button>
              </div> */}
      </div>
    
  )
}

export default Dashboard